import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import HelpIcon from '@mui/icons-material/Help';

const QuickStatsBar = ({ cardStatuses, isReady }) => {
  const getStatusCounts = () => {
    const counts = {
      go: 0,
      advisory: 0,
      caution: 0,
      'no-go': 0,
      unknown: 0
    };

    Object.values(cardStatuses).forEach(status => {
      if (counts[status] !== undefined) {
        counts[status]++;
      }
    });

    return counts;
  };

  const counts = getStatusCounts();

  const statItems = [
    {
      label: 'Clear',
      value: counts.go,
      icon: CheckCircleIcon,
      color: '#00E676'
    },
    {
      label: 'Advisory',
      value: counts.advisory,
      icon: HelpIcon,
      color: '#FFEA00'
    },
    {
      label: 'Caution',
      value: counts.caution,
      icon: WarningIcon,
      color: '#FF9100'
    },
    {
      label: 'No-Go',
      value: counts['no-go'],
      icon: ErrorIcon,
      color: '#FF5252'
    }
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        mb: 0,
        background: 'linear-gradient(135deg, rgba(25,118,210,0.1) 0%, rgba(25,118,210,0.05) 100%)',
        border: '1px solid rgba(255,255,255,0.1)'
      }}
    >
      <Typography variant="caption" sx={{ display: 'block', mb: 0.75, opacity: 0.7, fontWeight: 700 }}>
        System Status Overview
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          gap: 0.5,
        }}
      >
        {statItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 0.6,
                py: 0.5,
                minWidth: 0,
                borderRadius: 1,
                backgroundColor: item.value > 0 ? `${item.color}15` : 'rgba(255,255,255,0.03)'
              }}
            >
              <Icon sx={{ color: item.color, fontSize: 16, flexShrink: 0 }} />
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle2" sx={{ lineHeight: 1, color: item.color }}>
                  {item.value}
                </Typography>
                <Typography variant="caption" noWrap sx={{ display: 'block', opacity: 0.7, lineHeight: 1.1 }}>
                  {item.label}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
      {!isReady && (
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.6 }}>
          Loading data...
        </Typography>
      )}
    </Paper>
  );
};

export default QuickStatsBar;
